import { QueryClient } from "@tanstack/react-query";

// Public API reads are short-lived and safe to reuse between SPA navigations.
// Mutations and authenticated reads continue to use the API helpers directly.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});
